<template>
  <template v-for="menu in menus">
    <a-menu-item v-if="!hasChildren(menu)" :key="menu.path" @click="() => click(menu)">
      <template v-if="menu.icon" #icon>
        <huasky-icon :icon="menu.icon" />
      </template>
      <span>{{ menu.name }}</span>
    </a-menu-item>
    <a-sub-menu v-else :key="menu.name" :title="menu.name">
      <template v-if="menu.icon" #icon>
        <huasky-icon :icon="menu.icon" />
      </template>
      <nav-menu :menus="menu.children ?? []" />
    </a-sub-menu>
  </template>
</template>
<script setup lang="ts">

defineProps<{
  menus: SystemMenu[]
}>()

function hasChildren(menu: SystemMenu) {
  return menu.children && menu.children.length > 0
}

function click(menu: SystemMenu) {
  if (menu.path && menu.path.startsWith('/')) {
    $router.push(menu.path)
    return
  }
  window.open(menu.link)
}

</script>